import 'reflect-metadata';
export class BaseEntityDescriptor {
    name;
    constructor(name) {
        this.name = name;
    }
}
//# sourceMappingURL=BaseEntityDescriptor.js.map